import PaymentPlanTwoFactorAuthenticationError from './PaymentPlanTwoFactorAuthenticationError';
class InvestorHasAuthenticationFactorLocked extends PaymentPlanTwoFactorAuthenticationError {
    constructor(options) {
        super('Investor has authentication factor locked', options);
    }
}
export default InvestorHasAuthenticationFactorLocked;
